import { render, staticRenderFns } from "./level-manage.vue?vue&type=template&id=1f9cee84"
import script from "./level-manage.vue?vue&type=script&lang=js"
export * from "./level-manage.vue?vue&type=script&lang=js"
import style0 from "./level-manage.vue?vue&type=style&index=0&id=1f9cee84&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f9cee84')) {
      api.createRecord('1f9cee84', component.options)
    } else {
      api.reload('1f9cee84', component.options)
    }
    module.hot.accept("./level-manage.vue?vue&type=template&id=1f9cee84", function () {
      api.rerender('1f9cee84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/level-manage.vue"
export default component.exports